<template>
  <div class="selectedSubject">
    <h2>{{ selectedSubject.name }}</h2>
  </div>
</template>

<script setup lang="ts">
  import { useSubjectStore } from '@/store/subjectStore';
  import { computed } from 'vue';

  const subjectStore = useSubjectStore();
  const selectedSubject = computed(() => subjectStore.selectedSubject);
</script>

<style scoped lang="scss">
  .selectedSubject {
    text-align: center;
    border-bottom: solid 2px lighten-color($primaryColor, 10%);
    border-top: solid 2px lighten-color($primaryColor, 10%);
    margin-bottom: 1em;

    h2 {
      color: $primary2Color;
    }
  }
</style>
